<template>
<span v-if="showToday" v-html="opentext">


</span>
 <v-sheet color="transparent" v-else>
    <v-card-subtitle v-if="card" v-html="opentext"></v-card-subtitle>
  <v-card outlined class="mb-3" v-bind="$attrs">
   
  <v-simple-table dense style="background-color: transparent;">
    
    <template v-slot:default>
      <tbody>
        <tr
          v-for="item in timetable"
          :key="item.name"
          :class="{'primary white--text':item.day == toDay}"
        >
          <td>{{ item.text }}</td>
          <td v-if="!item.start || item.start =='00:00'" colspan="3">{{ item.description }}</td>
          <template v-else>
            <td>{{ item.start }}</td>
            <td>{{ item.end }}</td>
            <td>{{ item.description }}</td>
          </template>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  </v-card>
  </v-sheet>
</template>
<script>
import timeTable from '@/modules/timeTable'
export default {
   mixins: [timeTable],
   props: {
    value: {
      type: Array,
      default: function () {
        return []
      },
    },
    showToday: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    closed: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    card: {
      type: Boolean,
      default: function () {
        return false
      },
    }
   },
  data: () => ({
      selected: [3],
  }),
  computed: {
    
  },
  mounted () {
    this.init()
  },
watch: {
  value(){
    this.init()
  }
},
methods: {
    
    init(){
      if (this.value && this.value.length>0) this.setTimeTable({timetable: this.value, closed:this.closed})
       if (!this.value || this.value.length==0) this.$emit('input',this.timetable)
             //if (this.showToday) this.timetable = this.timetable.filter(t=>t.day==this.today)
           
    },
    update () {
        this.$emit('input',this.timetable)
    }    
  }
}


</script>
